/**
 * Get series from brightspot
 *
 */
import { gql } from '@apollo/client'

export const faqGQLQuery = () => {
  return gql(`{
    OneOffPage(id: "/rootstech-connect-faq") {
      content {
        ... on RichTextModule {
          body
        }
      }
    }
  }
  `)
}

export const dummy = () => {}
